<template>
    <section>
        <header class="mt-6 mb-0">
            <h1 class="fs-32 m-0 regular">
                {{ $l10n.__('Configurez votre évolution d’abonnement') }}
            </h1>
        </header>
        <article>
            <header class="flex-level mt-6 mb-5 pb-1">
                <h2 class="m-0">{{ $l10n.__('Ajouter des licences') }}</h2>
            </header>
            <el-form-item prop="products" class="mb-2">
                <LicenceProduct
                    v-for="product in availablesProducts"
                    :key="product.code"
                    class="mb-5"
                    :modelValue="products[product.id]"
                    :product="product"
                    :plan="plan"
                    userType="client"
                    :numformat="numformat"
                    @update:modelValue="updateProductQuantity"
                >
                </LicenceProduct>
            </el-form-item>
        </article>

        <div class="separator gray-05-bkg"></div>
        <!-- Extras Modules -->
        <article>
            <el-form-item>
                <header>
                    <h2 class="mb-5 mt-6">{{ $l10n.__('Modules supplémentaires') }}</h2>
                </header>
                <BonusPack
                    v-for="product in bonusPacksClient"
                    :key="product.code"
                    class="mb-5"
                    :modelValue="products[product.id]"
                    :product="product"
                    :plan="plan"
                    userType="client"
                    :numformat="numformat"
                    :sourceLimitation="isSourceSale"
                    @update:modelValue="updateProductQuantity"
                    @changePackPlan="switchPackPlan"
                >
                </BonusPack>
            </el-form-item>
        </article>
    </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import LicenceProduct from 'vcomponents/pages/account/LicenceProduct.vue';

import BonusPack from 'vcomponents/pages/account/BonusPack.vue';

const upsellCart = createNamespacedHelpers('upsellCart');
export default {
    components: {
        LicenceProduct,
        BonusPack,
    },
    computed: {
        ...upsellCart.mapGetters([
            'availablesProducts',
            'products',
            'plan',
            'numformat',
            'bonusPacksClient',
            'isSourceSale',
        ]),
    },
    methods: {
        ...upsellCart.mapActions(['updateProductQuantity', 'switchPackPlan']),
    },
};
</script>
